import { environment } from '@config/environment.config';
import { authStore } from '@services/authStore.service';

export interface UniqueFieldValidationRequest {
  fieldName: string;
  fieldValue: unknown;
  entityType: string;
  entityId?: string | null;
  formType?: string;
  requestType?: string | null;
  formTemplateId?: string | null;
}

export interface UniqueFieldValidationResponse {
  exists: boolean;
  entity?: Record<string, unknown>;
}

export async function validateUniqueField(
  request: UniqueFieldValidationRequest,
): Promise<UniqueFieldValidationResponse> {
  const base = environment.getIlaApiBaseUrl();
  const headers = {
    'Content-Type': 'application/json',
    ...authStore.getAuthHeader(),
  };

  const res = await fetch(`${base}/api/workspace/customField/validate/unique`, {
    method: 'POST',
    headers,
    body: JSON.stringify(request),
  });

  if (!res.ok) {
    throw new Error(`Unique field validation failed with status ${res.status}`);
  }

  const data = await res.json();
  return {
    exists: Boolean(data?.exists),
    entity: data?.entity,
  };
}
